// extracted by mini-css-extract-plugin
export default {"root":"FooterWrapperV8_root__36DOI"};